import { render } from "./YourDataOptions.vue?vue&type=template&id=57162284&scoped=true&ts=true"
import script from "./YourDataOptions.vue?vue&type=script&lang=ts"
export * from "./YourDataOptions.vue?vue&type=script&lang=ts"

import "./YourDataOptions.vue?vue&type=style&index=0&id=57162284&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57162284"]])

export default __exports__